// extracted by mini-css-extract-plugin
module.exports = {"uploaderWrapper":"styles-module__uploaderWrapper___2FI6S","note":"styles-module__note___3CgO5"};